import {
  SET_EMAIL_AND_PASSWORD,
  SET_NEW_PASSWORD,
  SET_PASSWORD_CONFIRM,
  CREATE_PASSWORD_REQUEST,
  CREATE_PASSWORD_SUCCESS,
  CREATE_PASSWORD_FAILURE,
  VALIDATE_CREATE_PASSWORD
} from 'constants/actionTypes';
import validateCreatePassword from 'utils/validateCreatePassword';

const initialState = {
  email: '',
  isFetching: false,
  password: '',
  passwordConfirm: '',
  token: '',
  errorText: ''
};

/**
 * Create New Password Reducer
 * @param {Object} state
 * @param {Object} action
 * @return {Object}
 */
export default function createNewPasswordReducer(state = initialState, action) {
  switch (action.type) {

    case SET_EMAIL_AND_PASSWORD:
      return {
        ...state,
        email: action.email,
        token: action.token
      };

    case SET_NEW_PASSWORD:
      return {
        ...state,
        password: action.value,
        errorText: ''
      };

    case SET_PASSWORD_CONFIRM:
      let errorText = '';
      if (state.password !== action.value) {
        errorText = 'notMatchingPasswords';
      } else if (state.password.length < 8) {
        errorText = 'shortPassword';
      }
      return {
        ...state,
        passwordConfirm: action.value,
        errorText
      };

    case CREATE_PASSWORD_REQUEST:
      return {
        ...state,
        isFetching: true
      };

    case CREATE_PASSWORD_SUCCESS:
      return {
        ...state,
        errorText: '',
        isFetching: false
      };

    case CREATE_PASSWORD_FAILURE:
      return {
        ...state,
        errorText: action.errorText,
        isFetching: false
      };

    case VALIDATE_CREATE_PASSWORD:
      const passwordLength = state.password.length;
      const validationError = validateCreatePassword(passwordLength, state);
      return {
        ...state,
        errorText: validationError
      };

    default:
      return state;
  }
}
